(function () {
  if (!window.__MARKET__) {
    console.warn('[AJP] Market context unavailable');
    return;
  }

  const context = {
    'AJP Market': window.__MARKET__.market || '',
    'AJP Country': window.__MARKET__.country || '',
    'AJP Currency': window.__MARKET__.currency || '',
    'AJP Storefront': window.location.hostname
  };

  async function persistMarketContext() {
    try {
      // Read the current cart first.
      const cartResponse = await fetch('/cart.js', {
        credentials: 'same-origin'
      });

      if (!cartResponse.ok) {
        throw new Error('Could not read cart');
      }

      const cart = await cartResponse.json();
      const existing = cart.attributes || {};

      // Don't POST anything if the cart already contains
      // the correct market context.
      const needsUpdate = Object.entries(context).some(
        ([key, value]) => existing[key] !== value
      );

      if (!needsUpdate) {
        return;
      }

      const updateResponse = await fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: context
        })
      });

      if (!updateResponse.ok) {
        throw new Error('Could not update cart');
      }

      console.log('[AJP] Cart market context saved:', context);

    } catch (error) {
      console.warn('[AJP] Cart market context failed:', error);
    }
  }

  persistMarketContext();
})();